import React from 'react';
import { ReportingContainerBaseConfig } from '../../../base';
import { RecordNewController } from './recordNewInterface';
import { RecordNewContainerProps, RecordNewViewProps } from './recordNewProps';
import { RecordNewLoader } from './recordNewInterface';
import { RecordFormService } from '../form';

export function createRecordNewContainer(
    config: ReportingContainerBaseConfig & {
        service: {
            record: {
                form: RecordFormService;
            };
        };
    },
    loader: RecordNewLoader,
    controller: RecordNewController,
    View: React.FC<RecordNewViewProps>
): React.FC<RecordNewContainerProps> {
    const {
        kernel: {
            infra: {
                toaster: { useToast },
                optionParser: { useOptions },
            },
        },
        repository: { research: repository },
        context: { useContext },
        service: {
            record: { form: recordFormService },
        },
    } = config;

    return ({ ...containerProps }) => {
        const toast = useToast();
        const context = useContext();
        const mutation = {
            record: {
                create: repository.record.useCreate(context),
            },
        };
        const data = loader.useLoad(context, {
            collection: {
                id: containerProps.collection.id,
            },
        });

        const service = recordFormService.useProps(context, data.form);

        const values = service.form.watch();
        const props = controller.useProps(context, data, {
            form: {
                values,
                form: {
                    id: 'record-new',
                    form: service.form,
                    async onSubmit(values) {
                        console.log('data', values);
                        const response = await mutation.record.create.mutateAsync({
                            type: 'document',
                            title: undefined,
                            collection: data.form.collection.id,
                            properties: values.properties,
                            blocks: [],
                        });
                        console.log('response', response);
                        service.form.reset();
                        containerProps.onClose();
                        toast({
                            kind: 'success',
                            description: 'Record created',
                        });
                    },
                    onSubmitError(error) {
                        console.error('submit error', error);
                        toast({
                            kind: 'error',
                            description: 'Error creating record',
                        });
                    },
                    onError(error) {
                        console.error('form error', error);
                        toast({
                            kind: 'error',
                            description: 'Invalid form data',
                        });
                    },
                },
                property: {
                    value: service.fields.properties.value,
                    onChange(value) {
                        service.fields.properties.onChange(value);
                    },
                },
            },
        });

        return <View {...props} />;
    };
}
